import React from "react";
import { Toaster } from "react-hot-toast";
import Layout from "../components/Layout";
import Banner from "../components/shared/Banner";
import Seo from "../components/seo/seo";
import CallToAction from "../components/shared/CallToAction";
const Contact = () => {
  const breadcrumbList = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "InfyOm",
        item: "https://infyom.com",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Contact Us",
        item: "https://infyom.com/contact-us",
      },
    ],
  };
  return (
    <Layout>
      <Seo
        title="Contact Us | InfyOm Technologies"
        description="Get in touch with the InfyOm Technologies team to leverage the latest technologies and optimize your business processes. Contact us today to get started!"
        breadcrumbList={breadcrumbList}
      />
      <Toaster position="top-center" />
      <Banner
        isIndexPage="true"
        heading="Contact Us"
        subheading="We love to hear about your ideas and the challenges that you have. Let's discuss it together and bring your idea into existence."
      />
      <section>
        <div className="bg-white  rounded-lg h-full">
          <iframe
            className="w-full h-[420px]"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8666.20676878354!2d72.88163885719966!3d21.237576575063684!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f48b6c140a3%3A0x6aae5a9a1643f6f!2sInfyOm%20Technologies!5e0!3m2!1sen!2sin!4v1727932292847!5m2!1sen!2sin"
            allowFullScreen=""
            referrerPolicy="no-referrer-when-downgrade"
            title="InfyOm Technologies"
          ></iframe>
        </div>
      </section>
      <CallToAction text="Contact Us to Learn More." buttonText="Contact Us" isQuoteModal />
    </Layout>
  );
};

export default Contact;
